<!-- Close comparison button -->
<div class="row" *ngIf="comparisonActive" id="closeComparisonWrapper">
  <div class="col-4"></div>
  <div class="col-4 text-center">
    <button type="button" id="closeComparisonButton" class="btn btn-lg btn-light" (click)="closeComparison()">
      <span id="black" i18n="animations|@@close_comparison_mode">
        Fermer la comparaison
      </span>
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
  <div class="col-4"></div>
</div>

<div id="container-full" class="container-fluid bg-light fullscreen " (window:resize)="resetSize()">
  <div class="row">
    <div class="fullscreen">
      <p class="anim-description-action" [class.anim-description-action-camera]="showCam"
        *ngIf="isLoadingPicture && !isSliding" i18n="animations|@@loading_picture">
        Chargement en cours...
      </p>
      <p class="anim-description-action" [class.anim-description-action-camera]="showCam"
        *ngIf="isSliding && (tchek.uploadHDPictures || (isLocal && tchek.isHDLocal !== false))"
        i18n="animations|@@mouseup_for_better_quality">
        Relâcher le curseur pour charger une image de meilleure qualité
      </p>
      <!-- LOADING SPINNER <div class="lds-css ng-scope"><div style="width:100%;height:100%" class="lds-wedges"></div></div>-->
      <button type="button" class="close float-right ml-2" aria-label="Close"></button>
      <!-- <button *ngIf="!isFull" type="button" class="btn btn-outline-info float-right ml-2 btn_full" (click)="setFull()">
        <i class="fa fa-arrows-alt fa-fw" aria-hidden="true"></i>
      </button>-->
      <!-- <button type="button" class="btn btn-outline-info float-right ml-2 btn_full2" [ngClass]="showCam ? 'active' : ''"
        (click)="showCam = !showCam">
        <i class="fa fa-camera col-sm text-center" aria-hidden="true"></i>
      </button> -->
      <button type="button" id="btn-dismiss" class="btn btn-outline-danger btn-top-right" (click)="dismissSlider()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <button type="button" id="btn-help" class="btn btn-outline-light btn-top-right" placement="bottom-right"
        [ngbPopover]="popHelpContent">
        <i class="fa fa-question" aria-hidden="true"></i>
        <i class="fa fa-caret-down" aria-hidden="true"></i>
      </button>
      <div class="row">
        <div [ngClass]="comparisonActive ? 'col-6' : 'col-12'" class="p-0 m-0" id="col-c0">
          <app-canvas #canvas0 [tchekId]="tchekId" [insideClassificationImage]='insideClassificationImage'
            [cameraNumber]="camName" [pictureNumber]="getCanvasNumberPic(0)" [videoNumber]="getCanvasNumberVideo(0)"
            [editMode]="toggleEdit" (state)="newCanvasStateHandler($event)" [fgamma]="getCanvasParameter(cp.GAMMA, 0)"
            [fcontrast]="getCanvasParameter(cp.CONTRAST, 0)" [fsaturation]="getCanvasParameter(cp.SATURATION, 0)"
            [finversion]="getCanvasParameter(cp.INVERSION, 0)" [fmirror]="getCanvasParameter(cp.MIRROR,0)"
            [canvasId]="0" [compareMode]="comparisonActive" [annotateMode]="toggleAnnotate"
            [minProbVehicle]="minProbVehicle" (editingRoi)="setEditingCanvas($event)" [currentMode]="currentMode"
            [tchek]="tchek" (annotateModeChange)="changeAnnoateMode($event)">
          </app-canvas>
        </div>
        <div *ngIf="tchekIdComparison" class="col-6 p-0 m-0" id="col-c1"
          [ngStyle]="{ display: comparisonActive ? 'inherit' : 'none' }">
          <app-canvas #canvas1 [tchekId]="tchekIdComparison" [insideClassificationImage]='insideClassificationImage'
            [cameraNumber]="reverseCamera()" [pictureNumber]="getCanvasNumberPic(1)"
            [videoNumber]="getCanvasNumberVideo(1)" [editMode]="toggleEdit" (state)="newCanvasStateHandler($event)"
            [fgamma]="getCanvasParameter(cp.GAMMA, 1)" [fcontrast]="getCanvasParameter(cp.CONTRAST, 1)"
            [fsaturation]="getCanvasParameter(cp.SATURATION, 1)" [finversion]="getCanvasParameter(cp.INVERSION, 1)"
            [fmirror]="getCanvasParameter(cp.MIRROR,1)" [canvasId]="1" [compareMode]="comparisonActive"
            [annotateMode]="toggleAnnotate" [minProbVehicle]="minProbVehicle" (editingRoi)="setEditingCanvas($event)"
            [currentMode]='currentMode' [tchek]="tchek" (annotateModeChange)="changeAnnoateMode($event)">
          </app-canvas>
        </div>
      </div>


      <app-classificationImageToggleComponent *ngIf="insideClassificationImage" [currentImage]='currentImage'>
      </app-classificationImageToggleComponent>

      <app-roi-drawer *ngIf="insideClassificationImage !== true" [tchekId]="tchekId" [cameraName]="camName"
        [currentMode]='currentMode' [currentImage]='currentImage' (itemClick)="handleRoiDrawerClick($event)"
        (damageDeleted)="handleDamageDeleted($event)" (damageSelected)="handleDamageSelected($event)">
      </app-roi-drawer>

      <app-annotation-drawer *ngIf="isSuperAdmin && insideClassificationImage !== true" [tchekId]="tchekId"
        [cameraName]="camName" [isAnnotated]="isAnnotated" [forValidation]="forValidation"
        (onAnnotated)="tchekIsAnnotated()" (onValidation)="tchekForValidation()" [tchek]='tchek'
        [currentImage]="currentImage" [pictureNumber]="toPictureName(routerNumberPic)" [isSliding]='isSliding'>
      </app-annotation-drawer>

      <div class="uploadToCloudWrapper"
        *ngIf=" insideClassificationImage !== true && isSuperAdmin && tchek !== undefined && tchek.isUploaded">
        <button class="btn btn-light uploadToCloud" (click)="handleRequestHdTchek($event)"
          style="color: black;cursor: pointer;" *ngIf="isLocal === false">
          <i class="fa fa-cloud-upload"
            *ngIf="(tchek.toDownload !== 1 && !tchek.uploadHDPictures && tchek.videoConverter !== 2)"></i>
          <i class="fa fa-cloud" *ngIf="tchek.uploadHDPictures && tchek.videoConverter === 2 && tchek.toDownload !== 1"
            style="color: Tomato;"></i>
          <i class='fa fa-circle-o-notch fa-spin' *ngIf="tchek.toDownload === 1"></i>
          <i class="fa fa-cloud" aria-hidden="true"
            *ngIf="tchek.uploadHDPictures && tchek.videoConverter !== 2 && tchek.toDownload !== 1"></i>
        </button>
        <button
          *ngIf="!tchek.uploadHDPictures && (isLocal === false || tchek.isDeletedLocal !== true) &&  tchek.toDownload !== 1"
          class="btn btn-light extractVideo" (click)="handleRequestExtractVideo($event)"
          style="color: black;cursor: pointer;">
          <i class="fa fa-camera  " *ngIf="tchek.videoConverter !== 1 && tchek.videoConverter !== 2"></i>
          <i class='fa fa-circle-o-notch fa-spin' *ngIf="tchek.videoConverter ===1"></i>
          <i class="fa fa-image" aria-hidden="true" *ngIf="tchek.videoConverter === 2"></i>
        </button>
      </div>

      <div id="imageContainer" class="row container-fluid "
        *ngIf="insideClassificationImage !== true && currentMode === 'image' && tchek && tchek.images && tchek.images.length > 0">
        <div class="col-12">
          <ul #picture class="containerScroll d-none">
            <li *ngFor="let image of tchek.images" class="imageBlock">
              <img *ngIf="image.child" [ngClass]="{'selectedImage': this.currentImage === image,
              'isDeleted ' : image.isDeleted}" (click)='switchToImage(image)' style="z-index: 12;" class='ImageOver'
                src='{{image.child.file.url()}}' (load)="picture.classList.remove('d-none')" crossorigin="anonymous" />
              <img [ngClass]="{'selectedImage': this.currentImage === image,
              'isDeleted ' : image.isDeleted}" (click)='switchToImage(image)' style="z-index: 11;" class='Image '
                src='{{image.file.url()}}' (load)="picture.classList.remove('d-none')" crossorigin="anonymous" />
            </li>
          </ul>
        </div>
      </div>

      <footer id="anim-footer" class="navbar navbar-dark fixed-bottom animation-footer">
        <div *ngIf="insideClassificationImage ||(tchek && tchek.images)" class="row footer-anim container-fluid">
          <div class="col-md-auto pull-left">
            <div class="row align-items-start">
              <div class="col-sm btn-icon isroi" [ngClass]="tunnel ? 'active' : ''"
                *ngIf="insideClassificationImage !== true &&isSuperAdmin && tchek" (click)="switchtunnel()"
                id="editButton">
                <i class=" fa fa-train col-sm text-center " aria-hidden="true"></i>
                <p class="text-center" i18n="animations|@@tunnel">Tunnel</p>
              </div>
              <div *ngIf="user.canAnnotate && tchek; then annotate; else dontAnnotate">
              </div>
              <ng-template #annotate>
                <div class="col-sm btn-icon isroi" [ngClass]="toggleEdit ? 'active' : ''"
                  *ngIf="insideClassificationImage !== true && user && user.canEdit && notInplayerImages()"
                  (click)="toggleEditMode(popover)" id="editButton">
                  <i class=" fa fa-pencil col-sm text-center " aria-hidden="true"></i>
                  <p class="text-center" i18n="animations|@@edit">Editer</p>
                </div>
                <div class="col-sm d-flex mt-auto mb-auto" *ngIf="insideClassificationImage">
                  <span style=" display: inline-flex; margin: auto; ">
                    <p class="text-center mt-auto mb-auto" i18n="animations|@@skip">Skip</p>
                    <input type="number" class="skipInput" min="0" placeholder="200" [(ngModel)]="_imagesService.skip">
                    <button type="button" class="btn btn-lg primary w-100" (click)="reloadImagesSkip()">Reload</button>
                  </span>
                </div>
                <div class="col-sm btn-icon"
                  [ngClass]="{'active' : toggleAnnotate && isImageHd, 'isImageNotHd' : !isImageHd}"
                  #popover="ngbPopover" (click)="toggleAnnotateMode()" id="annotateButton" placement="top"
                  [ngbPopover]="popContentAnnotations" data-container="body">
                  <i class=" fa fa-object-ungroup col-sm text-center" aria-hidden="true"></i>
                  <p class="text-center" i18n="animations|@@annotate">Annoter</p>
                </div>
                <div class="col-sm d-flex mt-auto mb-auto" *ngIf="insideClassificationImage">
                  <p class="text-center mt-auto mb-auto"> <span i18n="animations|@@idImage">Images Id :</span>
                    {{this.currentImage.id}}</p>
                </div>
                <div class="col-sm d-flex mt-auto mb-auto"
                  *ngIf="insideClassificationImage && countEndClassification !== undefined">
                  <p class="text-center mt-auto mb-auto"> <span i18n="animations|@@countClassificationImage">Images
                      classifiées
                      :</span>
                    {{countEndClassification}}</p>
                </div>
              </ng-template>
              <ng-template #dontAnnotate>
                <div class="col-sm btn-icon isroi" [ngClass]="toggleEdit ? 'active' : ''"
                  *ngIf="insideClassificationImage !== true && user && user.canEdit && notInplayerImages()"
                  (click)="toggleEditMode()" id="editButton">
                  <i class=" fa fa-pencil col-sm text-center " aria-hidden="true"></i>
                  <p class="text-center" i18n="animations|@@edit">Editer</p>
                </div>
              </ng-template>
              <div #popoverIa="ngbPopover" class="col-sm btn-icon isroi" placement="top" [ngbPopover]="popContentIa"
                *ngIf="insideClassificationImage !== true && isSuperAdmin && currentMode === 'image' && tchek &&(tchek.type === 2 || tchek.type ===  4 ||  tchek.inspectedByAlto)">
                <i class="fa fa-rocket col-sm text-center " *ngIf="iaRunningInspection !== true" aria-hidden="true"></i>
                <i class='fa fa-circle-o-notch fa-spin col-sm text-center' *ngIf="iaRunningInspection"></i>
                <p class="text-center" i18n="animations|@@inspection">Inspection </p>
              </div>

              <div class="col-sm btn-icon isroi  "
                *ngIf="insideClassificationImage !== true && isSuperAdmin && currentMode === 'image' && tchek && tchek.inspectedByAlto && this.images">
                <button *ngIf="!existAPi" class="btn btn-primary " (click)='pdfApi()' i18n="animations|@@pdfApi">Pdf
                  API</button>
                <button *ngIf="existAPi" class="btn btn-secondary " i18n="animations|@@pdfApi">Pdf API :
                  {{statusReport}}%</button>
              </div>

              <div class="col-sm btn-icon isroi"
                *ngIf="insideClassificationImage !== true && isSuperAdmin && currentMode === 'image' && tchek &&(tchek.type === 2 || tchek.type ===  4 ||  tchek.inspectedByAlto) && this.images">
                <ng-select dropdownPosition="top" style="min-width: 100px;" [items]="images" [bindLabel]="'model'"
                  [bindValue]="'model'" [(ngModel)]="imageSelectedModel" [virtualScroll]='true' notFoundText="---"
                  [searchable]='true' [clearable]='false' placeholder='Model' (change)='changeModelIa($event)'>
                </ng-select>

              </div>
              <!--
              <div class="col-sm btn-icon" (click)="favThisPicture(undefined, favFiltersModal)">
                <i *ngIf="!isSelected" class="fa fa-star-o col-sm text-center" aria-hidden="true"></i>
                <i *ngIf="isSelected" class="fa fa-star col-sm text-center" aria-hidden="true"></i>
                <p class="text-centesr" i18n="animations|@@favorite">Favoris</p>
              </div>-->


              <div
                *ngIf="insideClassificationImage !== true && tchek&&tchek.type < 2 &&  ((tchek.images && tchek.images.length > 0) || tchek.underbody)"
                class="">
                <div *ngIf="currentMode !== 'image' && (tchek.images && tchek.images.length > 0)"
                  class="col-sm btn-icon" (click)='switchToImage()'>
                  <i class="fa fa-image item-up col-sm text-center" aria-hidden="true"></i>
                  <p class="text-center"><span i18n="animations|@@image">Images </span></p>
                </div>
                <div *ngIf="currentMode !== 'underbody' && tchek.underbody " class="col-sm btn-icon"
                  (click)='switchToUnderbody()'>
                  <i class="fa fa-image item-up col-sm text-center" aria-hidden="true"></i>
                  <p class="text-center"><span *ngIf=" tchek.underbody"
                      i18n="animations|@@underbody">Soubassement</span></p>
                </div>
                <div *ngIf="currentMode !== 'video'  " class="col-sm btn-icon" (click)='switchToVideo()'>
                  <i class="fa fa-video-camera item-up col-sm text-center" aria-hidden="true"></i>
                  <p class="text-center" i18n="animations|@@video">Video</p>
                </div>
              </div>

              <div class="col-sm btn-icon" [ngClass]="showFilter ? 'active' : ''" (click)="activeFilter()"
                *ngIf="user.canFilter">
                <i class="fa fa-magic item-up col-sm text-center" aria-hidden="true"></i>
              </div>
            </div>
          </div>



          <div class="col-sm rangeDiv text-center">
            <div class="row container-fluid">
              <div class="col-12">

                <p *ngIf="insideClassificationImage !== true && currentMode === 'image' && tchek.images.length < 1"
                  class="text-center" i18n="animations|@@noimagefortechek">Pas
                  d'images sur ce tchek</p>
                <input *ngIf="currentMode === 'video'" #animationRange type="range" min="0" max="99"
                  class="range slider" (input)="seekThroughVideo(animationRange.value)" [value]="routerNumberPic"
                  id="animation-slider" (mousedown)='touch($event)' (mouseup)='touch($event)'
                  (touchstart)='touch($event)' (touchend)='touch($event)' />

              </div>
            </div>
          </div>
          <div class="col-3" *ngIf="comparisonActive">
            <label class="tweaker-label" for="tweak-offset" i18n="animations|@@sequenceLag">
              Décalage de la séquence
            </label>
            <input type="range" id="tweak-offset" min="-10" max="10" step="1" class="range slider-small"
              [(ngModel)]="offset" [attr.disabled]="comparisonActive ? null : true"
              [ngClass]="{ 'disabled-input': !comparisonActive }" />
          </div>
          <app-comparison-modal *ngIf="comparisonActive !== true" [button]='"fast"' [vehicleId]="vehicleId"
            [tchekId]="tchekId" (onTchekSelected)="openComparison($event)">
          </app-comparison-modal>

          <div class="col-sm-1">
            <div class="row align-items-start">
              <div class="col-sm btn-icon" placement="top" [ngbPopover]="popContent">
                <i class="fa fa-cog item-up col-sm text-center" aria-hidden="true" style="margin-left:-5px"></i>
                <p class="text-center" i18n="animations|@@image_tools">
                  Outils
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="insideClassificationImage !== true">
            <img src="assets/icon/tchek-blue.svg" height="30" class="brand pull-right" alt="Tchek logo" />
          </div>
        </div>
      </footer>


    </div>
  </div>
</div>


<!-- Modal new ROI -->
<div class="modal fade" id="newRoiModal" tabindex="-1" role="dialog" aria-labelledby="newRoiModalLabel"
  aria-hidden="true">
  <!-- <app-roi-edit-modal (onSave)="saveRoiProxy($event)" (onCancel)="cancelRoiProxy()"></app-roi-edit-modal> -->
</div>

<!-- Modal edit ROI -->
<div class="modal fade" id="editRoiModal" tabindex="-1" role="dialog" aria-labelledby="editRoiModalLabel"
  aria-hidden="true">
  <!-- <app-roi-edit-modal (onSave)="editRoiProxy($event)" (onCancel)="cancelEditRoiProxy()" [roi]="_roiService.getRoiToEdit()"></app-roi-edit-modal> -->
</div>

<!-- Popover tweaker -->
<ng-template #popContent>
  <div class="col-12 mt-2 p-0 tweaker-body">
    <div class="d-iblock px-3">
      <div class="btn-group" role="group" *ngIf="comparisonActive">
        <button type="button" class="btn btn-wide" i18n="animations|@@left"
          [ngClass]="activeCanvas?'btn-outline-info':'btn-info'" (click)="setActiveCanvas(0)">Gauche</button>
        <button type="button" class="btn btn-wide" i18n="animations|@@right"
          [ngClass]="activeCanvas?'btn-info':'btn-outline-info'" (click)="setActiveCanvas(1)">Droite</button>
      </div>
    </div>
    <div class="d-iblock px-3 mt-3">
      <label class="tweaker-label" for="tweak-luminosité" i18n="animations@@brightness">Luminosité</label>
      <input type="range" id="tweak-gamma" min="0" max="2" step="0.003921" class="range slider-small"
        [(ngModel)]="gamma" />
    </div>
    <div class="d-iblock px-3">
      <label class="tweaker-label" for="tweak-contraste" i18n="animations@@contrasts">Contraste</label>
      <input type="range" id="tweak-contrast" min="-1" max="1" step="0.003921" class="range slider-small"
        [(ngModel)]="contrast" />
    </div>
    <div class="d-iblock px-3">
      <label class="tweaker-label" for="tweak-saturation" i18n="animations@@saturation">Saturation</label>
      <input type="range" id="tweak-saturation" min="-1" max="1" step="0.003921" class="range slider-small"
        [(ngModel)]="saturation" />
    </div>
    <div class="mt-3 px-3">
      <p class="tweaker-label" i18n="animations|@@switch_colors">Inverser les couleurs</p>
      <input class="tgl tgl-light" id="tweak-invert" type="checkbox" [(ngModel)]="inversion" />
      <label class="tgl-btn" for="tweak-invert"></label>
    </div>
    <div class="mt-3 px-3" *ngIf="comparisonActive && activeCanvas">
      <p class="tweaker-label" i18n="animations|@@add_mirror_effect">Appliquer un effet mirroir</p>
      <input class="tgl tgl-light" id="tweak-mirror" type="checkbox" [(ngModel)]="mirror" />
      <label class="tgl-btn" for="tweak-mirror"></label>
    </div>
    <div class="mt-3 px-3" *ngIf="isSuperAdmin">
      <label class="tweaker-label" data-toggle="tooltip" title="Set to -1 to disable">
        <input type="number" min="-1" max="100" [(ngModel)]="minProbVehicle" i18n="animations@@mini_roi_score" />
        Min ROI score
      </label>
    </div>
    <div class="mt-3 px-0 text-center">
      <app-comparison-modal *ngIf="comparisonActive !== true" [vehicleId]="vehicleId" [tchekId]="tchekId"
        (onTchekSelected)="openComparison($event)">
      </app-comparison-modal>
      <button type="button" class="btn-secondary btn btn-sm" (click)="resetFilters()" i18n="animations@@reset">
        Réinitialiser
      </button>
    </div>
  </div>
</ng-template>

<!-- Popover tweaker IA -->
<ng-template #popContentIa>
  <div class="col-12 mt-2 p-0 tweaker-body">
    <div class="d-iblock px-3 mt-3">
      <label class="tweaker-label" for="tweak-luminosité" i18n="animations|@@model">Model</label>
      <ng-select dropdownPosition="top" [items]="ModelIa" [bindLabel]="'name'" [bindValue]="'name'"
        [(ngModel)]="selectedModelIa" [virtualScroll]='true' notFoundText="---" [searchable]='true' [clearable]='false'
        placeholder='Model'>
      </ng-select>
    </div>
    <div class="d-iblock px-3 mt-3">
      <label class="tweaker-label" i18n="animations|@@score">Score</label>
      <input type="number" min="0.01" max='1' step='0.01' placeholder="200" [(ngModel)]="_imagesService.score">
    </div>
    <div class="d-iblock px-3 mt-3">
      <label class="tweaker-label" i18n="animations|@@createDamage">createDamage</label>
      <input type="checkbox" [(ngModel)]="_imagesService.createDamage">
    </div>
    <div class="d-iblock px-3 mt-3" *ngIf="getSelectedModelIaDesc()">
      <label class="tweaker-label" for="tweak-luminosité">{{getSelectedModelIaDesc()}}</label>
    </div>
    <div class="mt-3 px-0 text-center">
      <button type="button" class="btn btn-wide btn-info" (click)="inspectTchek()"> <img
          style="height: 35px; width: 35px;" *ngIf="iaRunningInspection === true" src="../../assets/images/spinner.gif"
          alt=""><span i18n="animations|@@runInspection">Lancer l'Inspection</span></button>
    </div>
  </div>
</ng-template>


<!-- Popover annotations -->
<ng-template #popContentAnnotations>
  <div class="col-12 mt-2 p-0 tweaker-body">
    <div class="d-iblock px-3">
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-wide" i18n="animations|@@damages"
          [ngClass]="annotationMode === 0?'btn-info':'btn-outline-info'"
          (click)="changeannotationModeType(0);">Dommages</button>
        <button type="button" class="btn btn-wide" i18n="animations|@@part"
          [ngClass]="annotationMode === 1?'btn-info':'btn-outline-info'"
          (click)="changeannotationModeType(1);">Pièces</button>
      </div>
    </div>
    <div class="d-iblock px-3 mt-3" *ngIf="annotationMode===0; else annotationPiecesMode">
      <ng-select dropdownPosition="top" [items]="listDamages" [virtualScroll]='true' notFoundText="---"
        (change)="setDamageForAnnotation($event)" [searchable]='true' [clearable]='false'
        placeholder='{{listDamages[0]}}'>
      </ng-select>
    </div>
  </div>
</ng-template>

<!-- French Popover helper -->
<ng-template #popHelpContent>
  <div class="col-12 mt-2 p-0 helper-body">
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" i18n="animations@@help_and_shortcuts">Aide et raccourcis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row"><i class="fa fa-mouse-pointer" aria-hidden="true"></i></th>
          <td i18n="animations@@helpDoubleClickForEdit">double-cliquer en mode édition vous permet d'éditer un
            dommage.
          </td>
        </tr>
        <tr>
          <th scope="row"><i class="fa fa-arrows" aria-hidden="true"></i></th>
          <td i18n="animations@@helpClickDragImage">Cliquez, maintenez et faites glisser pour déplacer l'image lorsque
            vous n'êtes pas en mode Édition. </td>
        </tr>
        <tr>
          <th scope="row"><kbd>R</kbd></th>
          <td i18n="animations@@helpResetZoom">Réinitialise le zoom et le panoramique.</td>
        </tr>
        <tr>
          <th scope="row"><kbd>◀</kbd> <kbd>▶</kbd> <kbd>▲</kbd> <kbd>▼</kbd></th>
          <td i18n="animations@@helpKeyboardChangeCam">Utiliser les flèches du clavier pour changer de camera.</td>
        </tr>

        <tr>
          <th scope="row"><kbd>Del</kbd></th>
          <td i18n="animations@@helpDelDamage">Supprime le dommage sélectionné en mode Édition.</td>
        </tr>
        <tr>
          <th scope="row"><i class="fa fa-arrows-v" aria-hidden="true"></i></th>
          <td i18n="animations@@helpZoom">Utiliser la molette pour zoomer et dézoomer.</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<!-- English Popover helper 
<ng-template #popHelpContent>
  <div class="col-12 mt-2 p-0 helper-body">
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Help and shortcuts</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row"><i class="fa fa-mouse-pointer" aria-hidden="true"></i></th>
          <td>Double click in <strong>Edit mode</strong> allows you to edit an
            ROI</td>
        </tr>
        <tr>
          <th scope="row"><i class="fa fa-arrows" aria-hidden="true"></i></th>
          <td>Click, hold and drag to pan the image when you're not in <strong>Edit
              mode</strong></td>
        </tr>
        <tr>
          <th scope="row"><kbd>R</kbd></th>
          <td>Resets zoom and panning</td>
        </tr>
        <tr>
          <th scope="row"><kbd>M</kbd></th>
          <td>Toggles parts detection mode ON and OFF</td>
        </tr>

        <tr>
          <th scope="row"><kbd>Del</kbd></th>
          <td>Deletes the selected ROI in <strong>Edit mode</strong></td>
        </tr>
        <tr>
          <th scope="row"><i class="fa fa-arrows-v" aria-hidden="true"></i></th>
          <td>Scrolling allows you to zoom in and out</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template> -->

<!-- Favorite with filters modal -->
<ng-template #favFiltersModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" i18n="animations|@@save_image_with_filters?" i18n="animations|@@save_image_with_filters">
      Sauvegarder l'image avec les modifications?
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="favFiltersModalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p i18n="animations|@@image_has_filters_choose_what_to_save">
      Des modifications ont été appliquées sur cette image.
      <br />
      <br />
      Choisissez si vous souhaitez sauvegarder l'originale ou l'image avec les
      modifications.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" i18n="animations|@@save_original"
      (click)="favFiltersModalRef.close(false)">
      Sauvegarder l'originale
    </button>
    <button type="button" class="btn btn-primary" i18n="animations|@@save_update"
      (click)="favFiltersModalRef.close(true)">
      Sauvegarder avec les modifications
    </button>
  </div>
</ng-template>

<ng-template #annotationPiecesMode>
  <div class="d-iblock px-3 mt-3">
    <ng-select dropdownPosition="top" [items]="listPieces" [virtualScroll]='true' notFoundText="---"
      (change)="setPieceForAnnotation($event)" [searchable]='true' [clearable]='false' placeholder='{{listPieces[0]}}'>
    </ng-select>

  </div>
</ng-template>
<app-vehicle-angles [ngClass]="{'d-none': currentMode !== 'video'}" [currentMode]='currentMode'
  (angleChange)='angleChange($event)' [firstCam]="camName" [way]="way" [folders]='countFolders'></app-vehicle-angles>


// WEBPACK FOOTER //
// ./src/app/animation/animation.component.html